export default "__VITE_ASSET__ljXXGHye__"